import React from 'react';
import { Star, CheckCircle } from 'lucide-react';

const ReviewCard = ({ review, showCategory = true }) => {
  // Get initials from name
  const getInitials = (name) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <div className="review-card">
      <div className="review-card-header">
        <div className="review-avatar">
          {getInitials(review.name)}
        </div>
        <div className="review-header-info">
          <h4 className="review-author">{review.name}</h4>
          <p className="review-location">{review.location}</p>
        </div>
      </div>

      <div className="review-rating">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            size={16}
            fill={i < review.rating ? 'currentColor' : 'none'}
            className={i < review.rating ? 'star-filled' : 'star-empty'}
          />
        ))}
      </div>

      {showCategory && (
        <div className="review-category-tag">{review.category || review.job_type}</div>
      )}

      <div className="review-badges">
        {review.verified && (
          <span className="review-badge verified">
            <CheckCircle size={14} />
            hipages verified
          </span>
        )}
        {review.hired && (
          <span className="review-badge hired">Hired on hipages</span>
        )}
      </div>

      <p className="review-date">{review.date}</p>

      <p className="review-text">"{review.text || review.review_text}"</p>
    </div>
  );
};

export default ReviewCard;
